import React from 'react';

import {reduxForm} from 'redux-form';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import {FetchEntitiesFilters} from '../../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../../enums/entityPropertyTypes';
import {filterAlignmentTypes} from 'infrastructure/js/enums/filterAlignmentTypes';

class PartTypesViewGrid extends React.PureComponent{

  filterConfig = [
    {fieldName: 'businessId', filterName: 'partTypeBusinessId', getOptions: false},
    {fieldName: 'description', filterName: 'partTypeDescription', getOptions: true},
  ];

  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.parttypes.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.parttype.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'partTypeBusinessId',
        width: 300,
        fetchConfig: {
          entityType: EntityPropertyTypes.PART_TYPE_BUSINESS_ID,
          // filter: BO_EntityFilters.ALL,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
      },
      {
        fieldName: 'description',
        title: this.labels.get('columns.partname.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'partTypeDescription',
        filterAlignment: filterAlignmentTypes.RIGHT,
      },
    ]
  };

  render() {
    return (
      <div className="administration-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_PART_TYPES}
              columnsConfig = {this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'partTypesViewGrid'
  }
)(PartTypesViewGrid);
